import Checkbox from '@mui/material/Checkbox';
import React from "react";

interface CheckboxProps {
    id: string;
    checked: boolean;
    onChange: (checked: boolean) => void;
}

const CheckboxComponent = (props: CheckboxProps) => {
    return <Checkbox 
        id={props.id}
        checked={props.checked}
        onChange={(_, checked) => props.onChange(checked)}
    />
}

export default CheckboxComponent;